/* eslint-disable max-len */
import * as React from 'react';

function SvgDesk(props: React.SVGProps<SVGSVGElement>): any {
    return (
        <svg width="20" height="19" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M0 0V1.81818H0.909091V12.7273H2.72727V5.45455H10V12.7273H19.0909V1.81818H20V0H0ZM2.72727 1.81818H17.2727V3.63636H2.72727V1.81818ZM11.8182 5.45455H17.2727V7.27273H15.4545V6.36364H13.6364V7.27273H11.8182V5.45455ZM11.8182 9.09091H17.2727V10.9091H15.4545V10H13.6364V10.9091H11.8182V9.09091Z"
                fill="#000"
            />
        </svg>
    );
}

export default SvgDesk;
